import './Layout.less';
import './LayoutAdapt.less';

export const prefix = 'bm-c-layout';

export { default } from './Layout';
